<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">
        {{ (isNew ? 'shared.irrelevanceReopeningModal.titleAdd' : 'shared.irrelevanceReopeningModal.titleEdit') | translate }}
      </h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="onClose()"></button>
    </div>

    <div class="modal-body">
      <label class="fw-bold mb-3">{{ 'shared.irrelevanceReopeningModal.irrelevanceFilters' | translate }}</label>

      <div class="custom-switch mb-3">
        <input
          type="checkbox"
          id="filterIrrelevantMessages"
          data-switch="success"
          [(ngModel)]="data.filterIrrelevantMessages"
          />
        <label for="filterIrrelevantMessages">
          <span class="d-block fw-bold">
            {{ 'shared.irrelevanceReopeningModal.enableNonReopeningWords' | translate }}
          </span>
        </label>
      </div>

      <div class="custom-switch mb-4">
        <input
          type="checkbox"
          id="preventReopenForEmojiOnly"
          data-switch="success"
          [(ngModel)]="data.preventReopenForEmojiOnly"
          />
        <label for="preventReopenForEmojiOnly">
          <span class="d-block fw-bold">
            {{ 'shared.irrelevanceReopeningModal.doNotReopenWithEmojis' | translate }}
          </span>
        </label>
      </div>

      <label class="fw-bold">{{ 'shared.irrelevanceReopeningModal.nonReopeningWords' | translate }}</label>
      <span class="text-secondary small mb-2 d-block">
        {{ 'shared.irrelevanceReopeningModal.addWordsSeparatedByComma' | translate }}
      </span>

      <input
        #firstInput
        type="text"
        class="form-control mb-3"
        [(ngModel)]="newIrrelevantWord"
        [placeholder]="'shared.irrelevanceReopeningModal.wordsPlaceholder' | translate"
        (input)="onInputChange()"
        [disabled]="!data.filterIrrelevantMessages"
        />

      <div class="d-flex flex-wrap gap-2 mb-4 cursor-pointer">
        @for (word of irrelevantWordsList; track word) {
          <div
            class="badge bg-primary d-flex align-items-center px-3 py-2"
            (click)="removeIrrelevantWord(word)">
            {{ word }}
            <i class="ri-close-line ms-2"></i>
          </div>
        }
      </div>

      <label class="fw-bold mb-1">{{ 'shared.irrelevanceReopeningModal.ignoreAttendanceAfterTime' | translate }}</label>

      <div class="custom-switch mb-4">
        <input
          type="checkbox"
          id="checkedIgnoreAttendance"
          data-switch="success"
          [(ngModel)]="data.checkedIgnoreAttendance"
          />
        <label for="checkedIgnoreAttendance">
          <span class="d-block fw-bold">
            {{ 'shared.irrelevanceReopeningModal.enableIgnoreForPeriod' | translate }}
          </span>
        </label>
      </div>

      <label class="fw-bold mb-1">{{ 'shared.irrelevanceReopeningModal.ignoreAttendanceAfterClosure' | translate }}</label>
      <span class="text-secondary small mb-2 d-block">
        {{ 'shared.irrelevanceReopeningModal.minutesToIgnoreAfterClosure' | translate }}
      </span>
      <input
        type="number"
        class="form-control"
        [(ngModel)]="data.periodToIgnoreAttendance"
        [placeholder]="'shared.irrelevanceReopeningModal.minutesPlaceholder' | translate"
        [disabled]="!data.checkedIgnoreAttendance"
        />
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="onClose()">
        {{ 'shared.irrelevanceReopeningModal.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary d-flex align-items-center gap-2"
        [mat-dialog-close]="true"
        (click)="onSave()"
        >
        {{ (isNew ? 'shared.irrelevanceReopeningModal.save' : 'shared.irrelevanceReopeningModal.update') | translate }}
        @if (loading) {
          <mat-spinner [diameter]="20" [color]="'accent'" mode="indeterminate"></mat-spinner>
        }
      </button>
    </div>

  </div>
</div>
